<template>
  <AdminModal :title="`Últimos accesos · ${user.name || user.email}`" @close="$emit('close')">
    <p v-if="loading" class="ad-empty">Cargando…</p>
    <p v-else-if="error" class="ad-error">{{ error }}</p>
    <template v-else>
      <p v-if="!data.perDevice" class="ad-note">
        Las cuentas de inquilino no guardan historial por dispositivo.
        Último acceso: <strong>{{ formatDateTime(data.lastLoginAt) }}</strong>
      </p>
      <p v-else-if="!data.events.length" class="ad-empty">Esta cuenta aún no ha iniciado sesión.</p>
      <table v-else class="logins">
        <thead><tr><th>Fecha y hora</th><th>Dispositivo</th><th>Navegador</th></tr></thead>
        <tbody>
          <tr v-for="e in data.events" :key="e.id">
            <td class="ad-mono">{{ formatDateTime(e.createdAt) }}</td>
            <td>{{ e.deviceType }}</td>
            <td>{{ e.browser }}</td>
          </tr>
        </tbody>
      </table>
    </template>
    <template #footer>
      <button type="button" class="ad-btn ad-btn--ghost" @click="$emit('close')">Cerrar</button>
    </template>
  </AdminModal>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import AdminModal from './AdminModal.vue'
import { getUserLogins } from '@/services/superadmin'
import { formatDateTime, errorText } from './adminFormat'

const props = defineProps({ user: { type: Object, required: true } })
defineEmits(['close'])

const loading = ref(true)
const error = ref('')
const data = ref({ perDevice: true, events: [], lastLoginAt: null })

onMounted(async () => {
  try {
    data.value = await getUserLogins(props.user.kind, props.user.id)
  } catch (err) {
    error.value = errorText(err, 'No se pudo cargar el historial.')
  } finally {
    loading.value = false
  }
})
</script>

<style scoped>
.logins { width: 100%; border-collapse: collapse; }
.logins th { text-align: left; font: 600 11px Inter, sans-serif; color: #64748b; padding: 6px 8px; border-bottom: 1px solid #e8edf4; }
.logins td { padding: 8px; border-bottom: 1px solid #f1f5f9; font: 400 12px Inter, sans-serif; color: #475569; }
</style>